import { ListItemButton, ListItemContent } from "@mui/joy"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { AccountRow } from "./AccountRow"

export function AccountListItem({ account, ...props }) {
    return (
      <ListItemButton
        disabled={!account.can_view}
        component={Link}
        to={`/${account.node.type}/${account.node.slug}`}
        {...props}
      >
        <ListItemContent>
          <AccountRow account={account} />
        </ListItemContent> 
      </ListItemButton>
    )
}

AccountListItem.propTypes = {
    account: PropTypes.object.isRequired
}
